"use client"

import { useSearchParams } from "next/navigation"
import { useLocale, useTranslations } from "next-intl"

import { Button, Row } from "@/components/ui"
import { resolveSupportedLocale, servedLocales, type Locale } from "@/i18n/locales"
import { usePathname, useRouter } from "@/i18n/navigation"

// Compact ES/EN pill group matching the D1 nav, for the drawer's language row and
// the account page.
const SHORT: Record<Locale, string> = { "es-MX": "ES", "en-US": "EN" }

export const NavLanguageToggle = ({ className }: { className?: string }) => {
  const active = resolveSupportedLocale(useLocale())
  const router = useRouter()
  const pathname = usePathname()
  const search = useSearchParams().toString()
  const t = useTranslations("nav")

  const choose = (locale: Locale) => {
    if (locale === active) return
    router.replace(search ? `${pathname}?${search}` : pathname, { locale })
  }

  return (
    <Row role="group" aria-label={t("language")} gap="50" className={`bg-surface-subtle rounded-full p-50 ${className ?? ""}`}>
      {servedLocales(pathname).map((locale) => {
        const selected = locale === active
        return (
          <Button
            key={locale}
            variant="quiet"
            size="sm"
            aria-pressed={selected}
            onClick={() => choose(locale)}
            className={`text-caption-lg h-auto rounded-full px-300 py-100 font-bold ${selected ? "bg-surface text-fg-brand shadow-sm" : "text-fg-muted hover:text-fg"}`}
          >
            {SHORT[locale]}
          </Button>
        )
      })}
    </Row>
  )
}
